import React from 'react'
import PropTypes from 'prop-types'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'
import { MaterialIcon } from '@dsny/dsny-component-library'
import styles from '../Dropdowns.module.scss'
import { SearchCategory } from 'constants/enums'

const SearchResultMoreActionsDropdown = ({
  type,
  item,
  onShowModal,
  onPlayRelease,
  onDownloadRelease,
  onPlayTrack,
  onDownloadTrack
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const isTrack = type === SearchCategory.tracks
  const isRelease = type === SearchCategory.releases
  if (!isTrack && !isRelease) return null

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        style={{ justifySelf: 'center' }}
        onClick={(e) => e.stopPropagation()}
      >
        <MaterialIcon name="MoreVertical" color={theme.colors.neutralW100} />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          side="bottom"
          align="end"
          className={styles.DropdownMenuContent}
          style={{
            background: theme.colors.neutralW20,
            color: theme.colors.neutralW100
          }}
          sideOffset={5}
          avoidCollisions
        >
          {isTrack && (
            <>
              <DropdownMenu.Item
                className={styles.DropdownMenuItem}
                onClick={(e) => {
                  e.stopPropagation()
                  onPlayTrack?.(item)
                }}
              >
                {t('general.play')}
              </DropdownMenu.Item>
              <DropdownMenu.Item
                className={styles.DropdownMenuItem}
                onClick={(e) => {
                  e.stopPropagation()
                  onDownloadTrack?.(item)
                }}
              >
                {t('general.download')}
              </DropdownMenu.Item>
              <DropdownMenu.Item
                className={styles.DropdownMenuItem}
                onClick={(e) => {
                  e.stopPropagation()
                  onShowModal?.(item)
                }}
              >
                {t('general.more-actions')}
              </DropdownMenu.Item>
            </>
          )}

          {isRelease && (
            <>
              <DropdownMenu.Item
                className={styles.DropdownMenuItem}
                onClick={(e) => {
                  e.stopPropagation()
                  onPlayRelease?.(item)
                }}
              >
                {t('general.play')}
              </DropdownMenu.Item>
              <DropdownMenu.Item
                className={styles.DropdownMenuItem}
                onClick={(e) => {
                  e.stopPropagation()
                  onDownloadRelease?.(item)
                }}
              >
                {t('general.download')}
              </DropdownMenu.Item>
              <DropdownMenu.Item
                className={styles.DropdownMenuItem}
                onClick={(e) => {
                  e.stopPropagation()
                  onShowModal?.(item)
                }}
              >
                {t('general.more-actions')}
              </DropdownMenu.Item>
            </>
          )}

          <DropdownMenu.Arrow className={styles.DropdownMenuArrow} />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}

SearchResultMoreActionsDropdown.propTypes = {
  type: PropTypes.oneOf([
    SearchCategory.tracks,
    SearchCategory.releases,
    SearchCategory.artists,
    SearchCategory.labels
  ]).isRequired,
  item: PropTypes.object.isRequired,
  onShowModal: PropTypes.func,
  onPlayRelease: PropTypes.func,
  onDownloadRelease: PropTypes.func,
  onPlayTrack: PropTypes.func,
  onDownloadTrack: PropTypes.func
}

export default SearchResultMoreActionsDropdown
